import { Loader } from "@egovernments/digit-ui-react-components";
import React, {  useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { convertEpochToDateDMY } from "../../../utils";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { Button, Card } from "@mui/material";
import DialogContentModal from "../../../../../templates/ApplicationDetails/components/DialogContent";
import useDepartmentSelector from "../../citizen/TCPForms/hooks/useDepartmentSelector";
import PopApplication from "../../../../../templates/Forms/ProfessionalForm/PopApplicationProfessional";
import { OBPSService } from "../../../../../../libraries/src/services/elements/OBPS";
import TakeActionItem from "../../../../../templates/Forms/TakeActionItem";

const ownerApplications = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [smShowMs, setSmShowMs] = useState(false);
  const [idData, setIdData] = useState("");
  const [formType, setFormType] = useState("");
  const { control, register } = useForm();
  const tenantId = Digit.ULBService.getStateId() || 'up';
  const userInfo = Digit.UserService.getUser()?.info || {};
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const isEmployee = window.location.pathname.split("/").includes("employee");
  const limit = rowsPerPage;
  const [isUdFlow, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const departement = applicationFlow
  let type = "OWNER_REGISTRATION"
  //const { data, isLoading: loader, revalidate } = Digit.Hooks.obps.useBPAREGSearch(tenantId);
  const { data = {}, isLoading:loader, refetch } = Digit.Hooks.obps.useBPADetailsPage(tenantId, {}, { formType: type });


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [page, setPage] = React.useState(0);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#1f4a7c",
      color: theme.palette.common.white,
      fontSize: 16
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const [orderBy, setOrderBy] = useState('applicationNo'); // Initial sorting column
  const [order, setOrder] = useState('desc'); // Initial sorting order ('asc' or 'desc')
  // const [dataSort, setDataSort] = useState(); 
  // Function to handle sorting when a column header is clicked
  const handleSort = (column) => {
    if (orderBy === column) {
      setOrder(order === 'asc' ? 'desc' : 'asc');
    } else {
      setOrderBy(column);
      setOrder('asc');
    }
  };
  const sortedData = data?.ownerRegistration?.sort((a, b) => {
    if (order === 'asc') {
      return a[orderBy] < b[orderBy] ? -1 : 1;
    } else {
      return b[orderBy] < a[orderBy] ? -1 : 1;
    }
  });

  async function getApprovalLetter(applicationNumber) {
    const res = await OBPSService.designOfRegApprovalLetterPdf(tenantId, applicationNumber, {});
    const pdfBlob = new Blob([res?.data], {type: 'application/pdf'})
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl);
  }
  const closeModal2 = (item) => {
    setIdData(item?.applicationNo)
    setFormType("OWNER_REGISTRATION")
    if (item?.applicationNo != null) {
      setSmShowMs(true)
    }
    else {
      console.log("Application Number Null 11");
    }

    // anchorEl(false)
  };
  if (applicationFlow === null) {
    return <DepartmentSelector />;
  }

  return (
    <div>
      {loader && <Loader />}
      <div style={{ margin: "10px 5%" }}>
        <Paper sx={{ overflow: "hidden", marginY: 2 }}>
          <div style={{ marginLeft: "8px", fontSize: "24px" }}>{`${t("BPA_MY_APPLICATIONS")}`}</div>
          <TableContainer sx={{ maxHeight: 500 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Name</StyledTableCell>
                  <StyledTableCell>Mobile Number</StyledTableCell>
                  <StyledTableCell>
                    Application Number
                    <TableSortLabel
                      active={orderBy === 'applicationNumber'}
                      direction={orderBy === 'applicationNumber' ? order : 'asc'}
                      onClick={() => handleSort('applicationNumber')}
                    >

                    </TableSortLabel></StyledTableCell>
                  <StyledTableCell> Application Type</StyledTableCell>
                  <StyledTableCell>
                    Date
                    <TableSortLabel
                      active={orderBy === 'applicationDate'}
                      direction={orderBy === 'applicationDate' ? order : 'asc'}
                      onClick={() => handleSort('applicationDate')}
                    >
                    </TableSortLabel></StyledTableCell>

                  <StyledTableCell>
                    Status
                    <TableSortLabel
                      active={orderBy === 'status'}
                      direction={orderBy === 'status' ? order : 'asc'}
                      onClick={() => handleSort('status')}
                    >
                    </TableSortLabel>
                  </StyledTableCell>
                  <StyledTableCell>Payment</StyledTableCell>
                  <StyledTableCell>View Application</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedData?.map((item, index) => {
                  return (
                    <StyledTableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                      <StyledTableCell>{item?.landInfo?.owners?.[0]?.name}</StyledTableCell>
                      <StyledTableCell>{item?.landInfo?.owners?.[0]?.mobileNumber}</StyledTableCell>
                      <StyledTableCell
                        style={{ textDecoration: "underline blue 1px", cursor: "pointer", border: "1px solid #ddd", padding: " 8px" }}
                        onClick={() => {
                          window.localStorage.setItem("ApplicationStatus", item?.status);
                          history.push({
                            pathname: `/digit-ui/citizen/obps/architect/appendex10/${item?.applicationNo}`,
                            // search: `${item?.applicationNumber}`
                          });
                        }}
                      >
                        {item?.applicationNo}
                      </StyledTableCell>
                      <StyledTableCell component="th" scope="row">
                        {/* {t(`${item?.applicationType}`)} */}
                        Owner Registration.
                      </StyledTableCell>
                      <StyledTableCell component="th" scope="row">
                        {convertEpochToDateDMY(item?.applicationDate)}
                      </StyledTableCell>
                      <StyledTableCell component="th" scope="row">
                        {t(item?.status)}
                      </StyledTableCell>
                      <StyledTableCell>
                      {item?.status === 'FORWARD_TO_APPLICANT_PAYMENT' && <Button size="small" sx={{ ml: 1, fontSize: "10px", alignContent: "center", display: "flex" }} variant="contained" color="primary"
                            onClick={() => {
                              window.localStorage.setItem("ApplicationStatus", item?.status);
                              history.push({
                                pathname: `/digit-ui/citizen/payment/collect/FORM_11/${item?.applicationNo}`,
                                state: { paymentAmount: 1000 }
                              });
                            }}>
                            <span>Make Payment</span>
                          </Button>}
                      </StyledTableCell>
                      <StyledTableCell component="th" scope="row">
                        {!isEmployee && ["INITIATE", "UPLOAD_DOC", "REVERT_TO_APPLICANT"].includes(item?.status) ? (
                          <Button size="small" sx={{ ml: 1, fontSize: "10px", alignContent: "center", display: "flex" }} variant="contained" color="primary"
                            onClick={() => {
                              window.localStorage.setItem("ApplicationStatus", item?.status);
                              history.push({
                                pathname: `/digit-ui/citizen/obps/services/ownerPortal/${item?.applicationNo}`,
                              });
                            }}>
                            <span>ReSubmit</span>
                          </Button>
                        ) : (
                          <Button size="small" sx={{ ml: 1, fontSize: "10px", alignContent: "center", display: "flex" }} variant="contained" color="success" onClick={() => closeModal2(item)}>
                            <span>View</span>
                          </Button>
                        )}
                      </StyledTableCell>
                      {/* <StyledTableCell component="th" scope="row">
                    <Button size="small"  sx={{ml:1, fontSize:"10px", alignContent:"center",display:"flex"}}  variant="contained" color="success" onClick={() => closeModal2(item)}>
                  <span>View</span>
             </Button>
             </StyledTableCell> */}
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 75, 100]}
            component="div"
            count={data?.ownerRegistration?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>

      <DialogContentModal
        title={"Application Details"}
        dataOpen={smShowMs}
        onClose={() => { setSmShowMs(false) }}
      >
        <TakeActionItem
          id={idData}
          formType={formType}
        />

      </DialogContentModal>
    </div>

  );
};
export default ownerApplications;

